import React from "react";
import LogoLockup from "@/components/LogoLockup";

/**
 * Login centerpiece — official VdV lockup + editorial copy.
 * Always rendered in English regardless of site locale (auth-gate convention).
 */
export default function LoginHeader() {
  return (
    <div className="flex flex-col items-center text-center">
      <LogoLockup variant="full" size="2xl" tone="dark" />
      <span
        aria-hidden
        className="block mt-6"
        style={{ width: 60, height: 1, backgroundColor: "#A8B0B8" }}
      />

      <p
        className="eyebrow mt-7"
        style={{ letterSpacing: "0.35em", fontSize: 12, color: "#B8BEC2" }}
        data-testid="login-super-eyebrow"
      >
        Singular Experiences
      </p>
      <p
        className="eyebrow text-brass mt-3"
        style={{ letterSpacing: "0.32em", fontSize: 11 }}
        data-testid="login-eyebrow"
      >
        Exclusive Access
      </p>

      <h2
        className="font-display text-ivory mt-4"
        style={{ fontSize: "clamp(1.6rem, 2.4vw, 2rem)", lineHeight: 1.15 }}
        data-testid="login-title"
      >
        By invitation{" "}
        <span className="italic-quote font-normal" style={{ fontWeight: 400 }}>
          only.
        </span>
      </h2>

      <p
        className="italic-quote text-ivory/70 mt-4"
        style={{ fontSize: "0.98rem", lineHeight: 1.5, maxWidth: "30ch" }}
      >
        Enter your credentials to access the collection.
      </p>
    </div>
  );
}
